// import React from 'react';
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { history } from "./shared/_helpers/history";
import AppRoutes from "./routes"
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastProvider } from "./shared/context/ToastContext";
import { PushNotifications } from "./shared/components/push/PushNotifications";
function App() {
  return (
    <ToastProvider>
      {/* @ts-expect-error */}
      <HistoryRouter history={history}>
        <AppRoutes />
        <PushNotifications />
      </HistoryRouter>
    </ToastProvider>
  );
}

export default App;
